export var getItemsLimits = function (ownerDocument, children, initialValue, initialValueAlone) {
    if (initialValueAlone === void 0) { initialValueAlone = false; }
    var limits = [];
    if (initialValueAlone) {
        limits.push(initialValue);
    }
    Array.from(children).reduce(function (prev, curr) {
        var computedStyle = ownerDocument.defaultView.getComputedStyle(curr);
        var ownWidth = curr.clientWidth +
            parseFloat(computedStyle.marginLeft) +
            parseFloat(computedStyle.marginRight);
        var totalWidth = Number(prev) + Math.round(ownWidth);
        limits.push(totalWidth);
        return totalWidth;
    }, initialValue);
    return limits;
};
export var getAvailableWidth = function (ownerDocument, element) {
    var computedStyle = ownerDocument.defaultView.getComputedStyle(element);
    return (parseFloat(computedStyle.width) -
        parseFloat(computedStyle.paddingRight) -
        parseFloat(computedStyle.paddingLeft));
};
export var isHidden = function (idx, firstRendered, lastRendered) {
    var hidden = false;
    if (idx < firstRendered || idx > lastRendered) {
        hidden = true;
    }
    return hidden;
};
export var getIntervalOfDisplayedItems = function (screenWidth, tabsLimits, selectedIndex, initWidth) {
    if (selectedIndex === void 0) { selectedIndex = 0; }
    if (initWidth === void 0) { initWidth = 0; }
    var start = 0;
    var end = tabsLimits.length - 1;
    if (screenWidth < tabsLimits[end]) {
        if (screenWidth < tabsLimits[selectedIndex]) {
            end = selectedIndex;
            start = tabsLimits.findIndex(function (limit) {
                return tabsLimits[selectedIndex] + initWidth - limit < screenWidth;
            });
            start++;
        }
        else {
            end = tabsLimits.findIndex(function (limit) { return limit > screenWidth; });
            end--;
        }
    }
    return {
        start: start,
        end: end
    };
};
